import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'boi-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit, OnChanges {
  @Input() hasStickHeader = false;

  @ViewChild('stickyContent', { static: true }) stickyContent;
  @ViewChild('notStickyContent', { static: true }) notStickyContent;
  @Input() scrollStickyHeaderHeight = 190;
  @Input() mainHeaderHeight = 64;
  @Input() isFullWidthWithStickyRight = false;

  constructor(private readonly el: ElementRef, private readonly renderer: Renderer2) {}

  ngOnInit(): void {
    if (this.isFullWidthWithStickyRight) {
      this.renderer.addClass(this.el.nativeElement, 'is-full-width-with-sticky-right');
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasStickHeader !== undefined && !changes.hasStickHeader.currentValue) {
      this.removeStickyCssProperty();
    }
  }

  @HostListener('window:scroll')
  onScrollEvent(): void {
    if (!this.hasStickHeader) {
      return;
    }
    const scrollTop = document.querySelector('html').scrollTop;
    if (scrollTop > this.scrollStickyHeaderHeight) {
      this.renderer.addClass(this.stickyContent.nativeElement, 'fix-sticky-content');
      this.renderer.setStyle(this.notStickyContent.nativeElement, 'margin-top', `${this.scrollStickyHeaderHeight}px`);
      this.renderer.setStyle(
        this.stickyContent.nativeElement,
        'margin-top',
        `-${this.scrollStickyHeaderHeight - this.mainHeaderHeight}px`
      );
    } else {
      this.removeStickyCssProperty();
    }
  }

  private removeStickyCssProperty(): void {
    this.renderer.removeClass(this.stickyContent.nativeElement, 'fix-sticky-content');
    this.renderer.removeStyle(this.notStickyContent.nativeElement, 'margin-top');
    this.renderer.removeStyle(this.stickyContent.nativeElement, 'margin-top');
  }
}
